var poll_default = {
  "fontElementMap": "_1z5xO",
  "container": "t8yt-",
  "fullscreen": "-zbuD",
  "background_overlay": "v12ax",
  "with_image": "cPzUR",
  "options": "ynwGy",
  "webview": "VmbJj",
  "grid": "VTrJU",
  "option": "XIgds",
  "cta_button": "VvHZt",
  "add_option": "HGNly",
  "see_more": "_8jnPa",
  "list": "_-4TCG",
  "column": "k6Akj",
  "additional_note": "TmRZ7",
  "spinner": "yeJuv",
  "spin": "KVwZD",
  "shown": "cl9BZ",
  "error": "H-ozK"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
